module.exports = __webpack_public_path__ + "media/customizations/fccsa/logo-0757425c646ec77af5db4d231649305d.png";